import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<rect x="17" y="10" width="6" height="2" rx="1"/><path d="M26,4V28H6V4H26m0-2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z"/><path d="M14.73,7.78a.9.9,0,0,0-1.3,0l-2.21,2.36-.65-.69a.88.88,0,0,0-1.3,0,1,1,0,0,0,0,1.38l1.3,1.38a.87.87,0,0,0,1.3,0l2.86-3A1,1,0,0,0,14.73,7.78Z"/><path d="M14.73,14.78a.9.9,0,0,0-1.3,0l-2.21,2.36-.65-.69a.88.88,0,0,0-1.3,0,1,1,0,0,0,0,1.38l1.3,1.38a.87.87,0,0,0,1.3,0l2.86-3A1,1,0,0,0,14.73,14.78Z"/><rect x="17" y="17" width="6" height="2" rx="1"/><rect x="17" y="23" width="6" height="2" rx="1"/><rect x="10" y="23" width="4" height="2" rx="1"/>';
export var ChecklistOutlineSVG = function ChecklistOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
ChecklistOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(ChecklistOutlineSVG);